import {consoleError, consoleLog} from '@/libs/consoleHelper';

import {axiosInstance} from './apiManager';

let cancel;

export function Post(address, param, callBackSuccess, passingVariabel, callBackException, callBackFail) {
  axiosInstance
    .post(address, param)
    .then((response) => {
      if (response.status === 200 && typeof callBackSuccess === 'function') callBackSuccess(response, passingVariabel);
      else if (typeof callBackFail === 'function') {
        callBackFail(response, passingVariabel);
      }
    })
    .catch((error) => {
      if (typeof callBackException === 'function') callBackException(error, passingVariabel);
    });
  return true;
}
export function Get(address, param, callBackSuccess, passingVariabel, callBackException, callBackFail) {
  axiosInstance
    .get(address, param)
    .then((response) => {
      if (response.status === 200 && typeof callBackSuccess === 'function')
        callBackSuccess(response, passingVariabel, cancel);
      else if (typeof callBackFail === 'function') {
        callBackFail(response, passingVariabel);
      }
    })
    .catch((error) => {
      if (typeof callBackException === 'function') callBackException(error, passingVariabel);
    });
  return true;
}
export function Put(address, param, callBackSuccess, passingVariabel, callBackException, callBackFail) {
  axiosInstance
    .put(address, param)
    .then((response) => {
      if (response.status === 200 && typeof callBackSuccess === 'function') callBackSuccess(response, passingVariabel);
      else if (typeof callBackFail === 'function') {
        callBackFail(response, passingVariabel);
      }
    })
    .catch((error) => {
      if (typeof callBackException === 'function') callBackException(error, passingVariabel);
    });
  return true;
}
export function Delete(address, param, callBackSuccess, passingVariabel, callBackException, callBackFail) {
  axiosInstance
    .delete(address, param)
    .then((response) => {
      if (response.status === 200 && typeof callBackSuccess === 'function') callBackSuccess(response, passingVariabel);
      else if (typeof callBackFail === 'function') {
        callBackFail(response, passingVariabel);
      }
    })
    .catch((error) => {
      if (typeof callBackException === 'function') callBackException(error, passingVariabel);
    });
  return true;
}

/**
 * Get Http Request function with Promise using axios
 * @param {String} address
 * @param  {...any} param
 * @returns {Promise}
 */
export function GetRequest(address, ...param) {
  return new Promise((resolve, reject) => {
    // consoleLog(`[Get Request] => ${address}`, ...param);
    axiosInstance
      .get(address, ...param)
      .then((response) => {
        // consoleLog(`[Get Response] => ${address}`, response);
        resolve(response);
      })
      .catch((error) => {
        // consoleError(`[Get Error] => ${address}`, error);
        reject(error);
      });
  });
}

/**
 * Post Http Request function with Promise using axios
 * @param {String} address
 * @param  {...any} param
 * @returns {Promise}
 */
export function PostRequest(address, ...param) {
  return new Promise((resolve, reject) => {
    consoleLog(`[Post Request] => ${address}`, ...param);
    axiosInstance
      .post(address, ...param)
      .then((response) => {
        consoleLog(`[Post Response] => ${address}`, response);
        resolve(response);
      })
      .catch((error) => {
        consoleError(`[Post Error] => ${address}`, error);
        reject(error);
      });
  });
}

/**
 * Put Http Request function with Promise using axios
 * @param {String} address
 * @param  {...any} param
 * @returns {Promise}
 */
export function PutRequest(address, ...param) {
  return new Promise((resolve, reject) => {
    consoleLog(`[Put Request] => ${address}`, ...param);
    axiosInstance
      .put(address, ...param)
      .then((response) => {
        consoleLog(`[Put Response] => ${address}`, response);
        resolve(response);
      })
      .catch((error) => {
        consoleError(`[Put Error] => ${address}`, error);
        reject(error);
      });
  });
}

/**
 * Delete Http Request function with Promise using axios
 * @param {String} address
 * @param  {...any} param
 * @returns {Promise}
 */
export function DeleteRequest(address, ...param) {
  return new Promise((resolve, reject) => {
    consoleLog(`[Delete Request] => ${address}`, ...param);
    axiosInstance
      .delete(address, ...param)
      .then((response) => {
        consoleLog(`[Delete Response] => ${address}`, response);
        resolve(response);
      })
      .catch((error) => {
        consoleError(`[Delete Error] => ${address}`, error);
        reject(error);
      });
  });
}
